"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    titleContainer: {
        display: 'inline-flex',
        fontSize: '1.3125rem',
        lineHeight: '1.16667rem'
    },
    titleLeft: {
        fontWeight: 100
    },
    titleRight: {
        fontWeight: 700
    }
};
//# sourceMappingURL=title.styles.js.map